var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "customer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 81.433,
    viewBox: "0 0 100 81.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24103",
    "data-name": "Path 24103",
    d: "M24.425,41.991A18.711,18.711,0,1,0,5.714,23.282,18.711,18.711,0,0,0,24.425,41.991Zm0-30.87A12.163,12.163,0,1,1,12.262,23.284,12.163,12.163,0,0,1,24.425,11.121Z",
    transform: "translate(10.172 -4.57)",
    fill: "#005795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24104",
    "data-name": "Path 24104",
    d: "M33.164,35.828A13.914,13.914,0,1,0,19.25,21.914,13.914,13.914,0,0,0,33.164,35.828Zm0-21.281A7.366,7.366,0,1,1,25.8,21.914a7.366,7.366,0,0,1,7.366-7.366Z",
    transform: "translate(42.281 3.23)",
    fill: "#005795"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24105",
    "data-name": "Path 24105",
    d: "M76,17.9a25.288,25.288,0,0,0-18,7.563A35.279,35.279,0,0,0,21.008,20.8,34.116,34.116,0,0,0,1,51.716,3.3,3.3,0,0,0,4.333,54.99H67.2a3.3,3.3,0,0,0,3.333-3.274,33.534,33.534,0,0,0-.557-5.991h27.69A3.3,3.3,0,0,0,101,42.45,24.807,24.807,0,0,0,76,17.9ZM7.863,48.442A27.849,27.849,0,0,1,33.16,24.2a28.08,28.08,0,0,1,29.4,19.266,25.643,25.643,0,0,1,1.1,4.98Zm60.173-9.265a33.887,33.887,0,0,0-5.37-9.043,18.532,18.532,0,0,1,18.518-4.96,18.1,18.1,0,0,1,12.852,14Z",
    transform: "translate(-1 26.444)",
    fill: "#005795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.6a69703a2838735914a47989cbffcd25.svg";
export { ForwardRef as ReactComponent };